/**
 * Проценты в тексте — по локали интерфейса (FE-579).
 *
 * Знак «%» стоит в самих строках локалей («{{rate}} %»), а сюда приходит
 * только число. Подставленное в i18next как есть, число выводится без
 * локали: ставка 2550 б. п. становилась «25.5 %» в немецком тексте, а строка
 * «Satz» с `toFixed(0)` и вовсе округляла её до «26 %». В письме автохаусу
 * backend это уже решает сам (`_format_rate` → «25,5»).
 */

/** Ставка в базисных пунктах — числом процентов: 2500 → «25», 2550 → «25,5» (de). */
export function percentFromBps(bps: number, locale: string): string {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(bps / 100);
}

/** Процент с одним знаком: −3.4 → «−3,4» (de), «−3.4» (en). */
export function percentValue(value: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value);
}
